import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { LeadService } from 'services/leads.service';

export default function LeadProcess(props) {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setError] = useState("");
    const [page, setPage] = useState(1);
    const [wasSubmitted, setWasSubmitted] = useState([]);
    const [successMap, setSuccessMap] = useState([]);
    const [errorMap, setErrorMap] = useState([]);

    useEffect(() => {
        setLoading(true);
        LeadService.getLeads(page).then(resp => {
            if (resp && resp.Success) {
                setLeads(Array.isArray(resp.Data) ? resp.Data : []);
            } else {
                setLeads([]);
                const message = resp && resp.Message ? resp.Message : "Invalid API response";
                setError("Unable to retrieve data from the API. Return Message: " + message)
            }
            setLoading(false)
        }).catch(err => {
            setLeads([]);
            setError(err);
            setLoading(false);
        })
    }, [page])

    const next = () => {
        if (leads.length == 100) {
            setPage(page + 1);
        }
    }

    const previous = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    }

    const resubmit = (id) => {
        if (wasSubmitted.indexOf(id) !== -1) {
            return;
        }
        setWasSubmitted([...wasSubmitted, id]);
        console.log('resubmitting ID ' + id)
        LeadService.resubmit(id)
        .then(resp => {
            setSuccessMap([...successMap, id])
        })
        .catch(err => {
            setErrorMap([...errorMap, id])
        })
    }

    return (
        <div className="content">
            <h1 style={{textAlign: 'center'}}>List of processed leads.  Page {page}</h1>
            {
                errorMsg != "" && <div style={{color: "red", fontSize: '2rem', textAlign: "center"}}>{errorMsg}.<br/>Refreshing the page may resolve the problem.</div>
            }
            <div style={{width: "100%", display: 'flex'}}>
                <div style={{width: '50%'}}><Button disabled={page == 1} onClick={previous}>Previous</Button></div>
                <div style={{width: '50%', display: 'flex', justifyContent: 'flex-end'}}><Button disabled={leads.length < 100} onClick={next}>Next</Button></div>
            </div>
            <div style={{marginTop: "50px"}}>
                <table style={{width: '100%'}}>
                    <thead>
                        <tr>
                            <td><h3>Ago</h3></td>
                            <td><h3>Name</h3></td>
                            <td><h3>Address</h3></td>
                            <td><h3>Lead Source</h3></td>
                            <td><h3>Form Name</h3></td>
                            <td><h3>Status</h3></td>
                            <td><h3>&nbsp;</h3></td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            leads.map(l => {
                                var data = JSON.parse(l.Data)
                                var proc = moment(l.ProcessedTime)
                                var now = moment(new Date())
                                var diff = now.diff(proc)
                                const d = moment.duration(diff)
                                var ago = ""
                                if (d._data?.days != 0 ) {
                                    ago = d._data.days + " days ago"
                                } else if (d._data?.hours != 0) {
                                    ago = d._data.hours + " hours ago";
                                } else if (d.data?.minutes != 0) {
                                    ago = d._data.minutes + " minutes ago";
                                } else {
                                    ago = "seconds ago"
                                }

                                return (
                                    <tr>
                                        <td><h5>{ago}</h5></td>
                                        <td><h5>{data?.f_3_firstname || ''} {data?.f_4_lastname || ''}</h5></td>
                                        <td><h5>{data?.f_6_address1}</h5></td>
                                        <td><h5>{data?.f_595_leadsource || ''}</h5></td>
                                        <td><h5>{data?.f_661_formname || ''}</h5></td>
                                        <td><h5>{l?.Outcome || ''}</h5></td>
                                        <td>
                                            {
                                                errorMap.indexOf(l.LeadRawID) !== -1 && <div>Error</div>
                                            }
                                            {
                                                successMap.indexOf(l.LeadRawID) !== -1 && <div>Success</div>
                                            }
                                            <Button disabled={wasSubmitted.indexOf(l.LeadRawID) !== -1} onClick={() => resubmit(l.LeadRawID)}>Resubmit Lead</Button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

            </div>
        </div>
    )
}
